module.exports = __webpack_public_path__ + "media/images/new/icons/twitter-0d5f6acf0669c9f8787a8ba8b4d44b4e.png";